import React, { Component } from "react";

import axios from "../../axios";
import { setCookie } from "../../function";
import Loader from "../../component/loader/loader";

export default class SigninSSO extends Component {

	componentDidMount() {
		this.getUserDetails();
	}

	getUserDetails = async () => {
		try {
			const response = await axios.get("/api/auth/details", {});
			const {
				firstname, lastname, email, threatcop, path, type, userAgent,
				companyName, dashboard, accessLevel, billingType,
				isNewClient, isTAconnected, tacEnabled, devAgent, isDeepFakeEnabled
			} = response.data;

			localStorage.setItem("firstname", firstname);
			localStorage.setItem("lastname", lastname);
			localStorage.setItem("email", email);

			setCookie("threatcop", threatcop, 180);
			setCookie("logo", path, 30000);
			setCookie("userType", type, 30000);
			setCookie("userAgent", userAgent, 30000);
			setCookie("firstname", firstname, 30000);
			setCookie("username", companyName, 30000);
			setCookie("isDashboard", dashboard, 30000);
			setCookie("accessLevel", accessLevel, 30000);
			setCookie("billingType", billingType, 30000);
			setCookie("isNewClient", isNewClient, 30000);
			setCookie("isTAconnected", isTAconnected, 30000);
			setCookie("integrationModalOpened", false, 30000);
			setCookie("tacEnabled", tacEnabled, 30000);
			setCookie("isThreatcopUnleashedClosed", false, 30000);
			setCookie("devAgent", devAgent, 30000);
			setCookie("isDeepFakeEnabled", isDeepFakeEnabled, 30000);

			window.location.href = "/";
		} catch (error) {
			console.error("Error fetching user details:", error);
			window.location.href = "/";
		}
	};

	render() {
		return <Loader />;
	}
}
